// extracted by mini-css-extract-plugin
export default {"loadingOverLay":"app_loadingOverLay__e5vCC","loaderContainer":"app_loaderContainer__4DVMg"};